<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="trackNumDialog"
        persistent
        max-width="340px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('customer.addTrackNumberTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                :value="isDone"
                type="success"
              >
                {{ $t('common.addedSuccessfully') }}
              </v-alert>
              <v-alert
                :value="isFailed"
                type="error"
              >
                {{ $t('customer.cannotUpdateTrackNumber') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm3
                    md3
                  >
                    <v-text-field
                      :label="$t('columns.trackNumber') + '*'"
                      v-model="form.track_number"
                      :error-messages="errors.collect('Track number')"
                      v-validate="'required'"
                      data-vv-name="Track number"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-7pct"
                outline
                color="success"
              >{{ $t('common.add') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  props: ['trackNumDialog', 'orderId'],

  data() {
    return {
      form: {},
      isDone: false,
      isFailed: false
    }
  },

  methods: {
    closeDialog() {
      this.form = {}
      this.isDone = false
      this.isFailed = false
      this.$validator.reset()
      this.$emit('close')
      this.$emit('resetTable')
    },

    submitForm() {
      this.isDone = false
      this.isFailed = false

      this.$validator.validateAll().then((res) => {
        if (res) {
          var token = localStorage.getItem('access_token')
          Axios.put(`api/update_track_number/${this.orderId}`, this.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(() => {
            this.isDone = true
            setTimeout(() => {
              this.closeDialog()
            }, 2000)
          }).catch(() => {
            this.isFailed = true
          })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/addTrackNumber.vue